/**
 * Widget đặt lịch/liên hệ trên trang chi tiết BĐS.
 *
 * Hai chế độ:
 * - Mặc định: hiển thị giá, loại giao dịch, CTA liên hệ và gọi điện.
 * - showForm: chuyển sang ContactForm để gửi yêu cầu liên hệ.
 *
 * Gợi ý đăng nhập nếu user chưa xác thực.
 */
import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useLoginDialog } from '../../hooks/useLoginDialog';
import { TEXT } from '../../shared/languages';
import { formatPropertyPrice } from '../../shared/utils/formatCurrency';
import { ContactForm } from './ContactForm';

/**
 * Card booking/liên hệ sticky bên phải trang chi tiết BĐS.
 * @param {Object} props
 * @param {Object} props.property - BĐS hiện tại
 * @param {number} props.price - Giá hiển thị
 * @param {string} props.transactionType - 'sale' | 'rent'
 */
export const PropertyBookingCard = ({ property, price, transactionType }) => {
  const { isAuthenticated } = useAuth();
  const { openLoginDialog } = useLoginDialog();
  const [showForm, setShowForm] = useState(false);
  const t = TEXT.property.detail;
  const transaction = TEXT.property.transactionType;
  const categoryName = property.category?.name || TEXT.property.defaultCategory;
  const transactionLabel =
    transactionType === 'rent' ? transaction.rent : transaction.sale;

  // Chế độ form liên hệ — thay thế widget tóm tắt
  if (showForm) {
    return (
      <div className="booking-widget">
        <button type="button" className="booking-widget-back" onClick={() => setShowForm(false)}>
          ← {TEXT.common.back}
        </button>
        <ContactForm propertyId={property.id} />
      </div>
    );
  }

  return (
    <div className="booking-widget">
      <div className="booking-widget-price">
        <strong>{formatPropertyPrice(price)}</strong>
        {transactionType === 'rent' && <span>{t.perMonth}</span>}
      </div>

      <div className="booking-widget-fields">
        <div className="booking-widget-field">
          <label>{t.fieldTransaction}</label>
          <span>{transactionLabel}</span>
        </div>
        <div className="booking-widget-field">
          <label>{t.fieldCategory}</label>
          <span>{categoryName}</span>
        </div>
      </div>

      <button type="button" className="booking-widget-cta" onClick={() => setShowForm(true)}>
        {t.contactCta}
      </button>

      <a className="booking-widget-call" href="tel:0977545638">
        {TEXT.contact.callNow}
      </a>

      <p className="booking-widget-note">{t.bookingNote}</p>

      {!isAuthenticated && (
        <p className="booking-widget-login">
          <button type="button" className="booking-widget-login-link" onClick={() => openLoginDialog()}>
            {TEXT.nav.login}
          </button>{' '}
          {t.loginToSave}
        </p>
      )}
    </div>
  );
};
